import { storage } from '../firebase/config';
import { ref, getDownloadURL } from 'firebase/storage';

export class FontService {
  static async getFontUrls() {
    try {
      const fonts = {
        normal: await getDownloadURL(ref(storage, 'fonts/Roboto-Regular.ttf')),
        bold: await getDownloadURL(ref(storage, 'fonts/Roboto-Medium.ttf')),
        italics: await getDownloadURL(ref(storage, 'fonts/Roboto-Italic.ttf')),
        bolditalics: await getDownloadURL(ref(storage, 'fonts/Roboto-MediumItalic.ttf'))
      };
      return fonts;
    } catch (error) {
      console.error('Error loading fonts:', error);
      // Fallback to CDN fonts
      return {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      };
    }
  }
}
